// @flow
import React, { Component } from 'react';
import { compose } from 'redux';
import { type ContextRouter, withRouter } from 'react-router-dom';

import './MainMobileFooter.scss';
import MainMobileFooterItem from '../MainMobileFooterItem';

type Props = {
  url: string,
} & ContextRouter;

class MainMobileFooter extends Component<Props> {
  bizPropPop() {
    window.open(
      'https://images.cacheby.com/data-biz.pdf',
      'datasee',
      'width=600, height=853; scrollbars=yes',
    );
  }

  bizCommPop() {
    window.open(
      'http://www.ftc.go.kr/bizCommPop.do?wrkr_no=4648100805',
      'bizCommPop',
      'width=750, height=700;',
    );
  }

  escrowPop() {
    window.open(
      'https://okbfex.kbstar.com/quics?page=C021590&cc=b034066%3Ab035526&mHValue=13ca91ba4eb4bbbcbb3912f9fe6edfdb202004141813363',
      'escrowPop',
      'width=750, height=700;',
    );
  }

  render() {
    return (
      <footer className="MainMobileFooter">
        <nav className="nav">
          <ul>
            <MainMobileFooterItem
              href="https://datasee.notion.site/CacheBy-8647642876a246708be6694d14550dc9"
              name="회사소개"
            />
            <MainMobileFooterItem onClick={() => window.Tawk_API.toggle()} name="문의하기" />
            <MainMobileFooterItem href="https://forms.gle/Rj8L977m1ze3yjev8" name="입점신청" />
            {/* <MainMobileFooterItem to="/partners" name="파트너" /> */}
            <MainMobileFooterItem to="/policy/privacy" name="개인정보처리방침" />
            <MainMobileFooterItem to="/policy/terms" name="이용약관" />
            <MainMobileFooterItem href="https://labsby.com" name="랩스바이" />
            <MainMobileFooterItem to="/letters" name="바이오위클리" />
          </ul>
          <div className="ft">
            <div className="w1100">
              <div className="ft_top">
                <strong className="ft_title">information</strong>
                <div className="ft_info-txt top">
                  <div>상호명 : (주)데이터씨</div>
                  <div>대표이사 : 최영진</div>
                  <div>개인정보보호책임자 : 최영진</div>
                  <div>
                    사업자등록번호 : 464-81-00805
                    <a
                      onClick={this.bizPropPop}
                      rel="noopener noreferrer"
                      className="ft_info-business"
                    >
                      사업자등록증
                    </a>
                  </div>
                </div>
                <div className="ft_info-txt">
                  <div>
                    통신판매업신고 : 2020-서울서초-0268
                    <a
                      onClick={this.bizCommPop}
                      rel="noopener noreferrer"
                      className="ft_info-business"
                    >
                      사업자정보확인
                    </a>
                  </div>
                  <div>운영시간 : 평일 9시~12시/13시~18시(주말, 공휴일 휴무)</div>
                  <div>대표전화번호 : 02-585-1342</div>
                </div>
                <div className="ft_info-txt">
                  <div>이메일 : info@cacheby.com</div>
                  <div>서울시 서초구 동광로1길 52, 1층</div>
                </div>
              </div>
              <div className="ft_mid">
                <div className="ft_bank-account-info">
                  무통장 입금계좌 :{' '}
                  <span>기업은행 033-502993-01-019 / 신한은행 100-032-703829</span>
                  <span>예금주 : 주식회사 데이터씨</span>
                </div>
                <div>
                  KB에스크로 :{' '}
                  <a
                    onClick={this.escrowPop}
                    rel="noopener noreferrer"
                    className="ft_info-business"
                  >
                    가입확인
                  </a>
                </div>
              </div>
              <div className="ft_btm">
                <p className="ft_copy-right">
                  Copyright © 2021 <strong>DATASEE</strong> All rights reserved.
                </p>
              </div>
            </div>
            <div className="ft_alert-msg">
              <div className="w1100">
                <div className="ft_alert-msg-txt">
                  (주)데이터씨의 사전 서면동의 없이 캐시바이 사이트(PC, 모바일)의 일체의 정보,
                  콘텐츠 및 UI 등을 상업적 목적으로 전재, 전송, 스크래핑 등 무단 사용할 수 없습니다.
                </div>
                <div className="box"></div>
              </div>
            </div>
          </div>
        </nav>
      </footer>
    );
  }
}

export default compose(withRouter)(MainMobileFooter);



// WEBPACK FOOTER //
// ./src/components/main/MainMobileFooter/MainMobileFooter.js